import { Form, Input, Button, Card, Spin, Select } from "antd";
import { CustomerService } from "../../services/customer/CustomerService";
import { AccountGroupService } from "../../services/group/AccountGroupService";
import React, { Component } from "react";
import { showSuccessToast } from "../general/ToastHelper";
import withSharedStateConsumer from "../../contexts/shared-state/withSharedStateConsumer";
import { withRouter } from "react-router-dom";
import { handleError } from "../../utils/ErrorHandlers";
import Page from "../general/Page";
import "./Customer.css";
import "./CreateCustomer.css";
import { Constants } from "../../data/constants";
import { Translation } from "react-i18next";
import i18next from "i18next";

class CreateCustomerForm extends Component {
  customerService = new CustomerService();
  accountGroupService = new AccountGroupService();
  constructor(props) {
    super(props);
    this.props.context.setCurrentComponent("createCustomers");
    this.constants = new Constants();
    this.state = {
      confirmDirty: false,
      customer: {},
      isFetching: false,
      formLayout: "inline",
      editMode: false,
      recordData: this.props.recordData ? this.props.recordData.customerId : "",
      allCustomerSegments: [],
      addCustomerFromTicket: this.props.addCustomerFromTicket,
    };
  }

  async componentDidMount() {
    try {
      this.setState({ isFetching: true });
      if (this.props.editMode && this.props.recordData) {
        let data = await this.customerService.getCustomerById(
          this.props.context.session_id,
          this.state.recordData
        );
        this.setState({ customer: data.ivrCustomEntityObject });
      }

      let allCustomerSegments =
        await this.customerService.getAllCustomerSegmentsService(
          this.props.context.session_id
        );

      this.setState({
        allCustomerSegments: allCustomerSegments.ivrList,
        isFetching: false,
      });
      
    } catch (e) {
      this.setState({ isFetching: false });
      handleError(e);
    }
  }

  componentDidUpdate(prevProps) {
    if (prevProps.location.key !== this.props.location.key) {
      this.componentDidMount();
    }
  }

  async createCustomerApi(values) {
    let history = this.props.history;
    try {
      let data = await this.customerService.createCustomer(
        this.props.context.session_id,
        values
      );
      showSuccessToast(i18next.t(data.statusMsg));
      this.setState({ loading: false });
      this.props.form.resetFields();
      if (this.state.addCustomerFromTicket) {
        history.push("/home/ticket/create");
        this.setState({ addCustomerFromTicket: false });
      } else {
        history.push("/home/customers/");
      }
    } catch (e) {
      this.setState({ loading: false });
      handleError(e);
    }
  }

  async editCustomerApi(values) {
    values["customerId"] = this.props.recordData.customerId;
    try {
      let data = await this.customerService.editCustomer(
        this.props.context.session_id,
        values
      );
      let history = this.props.history;
      showSuccessToast(i18next.t(data.statusMsg));
      this.setState({ loading: false });
      this.props.form.resetFields();
      history.push("/home/customers");
    } catch (e) {
      this.setState({ loading: false });
      handleError(e);
    }
  }

  handleConfirm = (e) => {
    e.preventDefault();

    this.props.form.validateFields(async (err, values) => {
      try {
        if (!err) {
          this.setState({ loading: true });
          this.customerService = new CustomerService();
          if (this.props.editMode) {
            values["accountId"]= this.props.context.user.accountId
            this.editCustomerApi(values);
          } else {
            values["accountId"]= this.props.context.user.accountId

            this.createCustomerApi(values);
          }
        }
      } catch (e) {
        this.setState({ loading: false, visible: false });
        handleError(e);
      }
    });
  };

  render() {
    const { getFieldDecorator } = this.props.form;
    const formItemLayout = {
      labelCol: { span: this.props.context.curr_dir === "rtl" ? 10:6 },
      wrapperCol: { span: 14 },
    };
    let { isFetching, allCustomerSegments } = this.state;
const defaultSegment = this.state.allCustomerSegments[0]?.segment
    const { Option } = Select;
    const customerSegmentsOptions = allCustomerSegments.map((opt) => (
      <Option key={opt.segment} value={opt.segment}>
        {i18next.t(opt.segmentDescription)}
      </Option>
    ));
    return (
      <Translation>
        {(t) => (
          <Page
            title={
              this.props.editMode ? t("Edit Customer ") : t("Create Customer")
            }
            hasBackArrow={true}
            //hasBackArrow={this.props.recordData ? true : false}
            customerBack={this.props.recordData ? true : false}
            back={() => {
              this.props.back();
            }}
          >
            {isFetching ? (
              <Spin></Spin>
            ) : (
              <div>
                {this.state.addCustomerFromTicket ? (
                  <Form
                    className="form-style"
                    // style={{ paddingBottom: "2px" }}
                    {...formItemLayout}
                  >
                    <Form.Item label={t("Full Name")} {...formItemLayout}>
                      {getFieldDecorator("customerFullname", {
                        initialValue: this.state.customer.customerFullname,
                        rules: [
                          {
                            type: "string",
                            message: t("The input is not valid "),
                          },
                          {
                            required: true,
                            message: t("Please enter customer full name"),
                          },
                        ],
                      })(<Input />)}
                    </Form.Item>

                    <Form.Item label={t("Number")} {...formItemLayout}>
                      {getFieldDecorator("customerNumber", {
                        initialValue: this.state.customer.customerNumber,
                        rules: [
                          {
                            type: "string",
                            message: t("The input is not valid "),
                            max: 12,
                            min: 12,
                            pattern: "^([2][0][1])(?:[0]|[1]|[2]|[5])[0-9]*$",
                          },
                          {
                            required: true,
                            message: t("Please enter customer number"),
                          },
                        ],
                      })(<Input maxLength={12} placeholder="201XXXXXXXXX" />)}
                    </Form.Item>

                    <Form.Item label={t("Email")} {...formItemLayout}>
                      {getFieldDecorator("customerEmail", {
                        initialValue: this.state.customer.customerEmail,

                        rules: [
                          {
                            type: "email",
                            message: t("The input is not valid E-mail!"),
                          },
                          {
                            type: "string",
                            message: t("The input is not valid "),
                          },
                          {
                            required: false,
                            message: t("Please enter customer email"),
                          },
                        ],
                      })(<Input />)}
                    </Form.Item>

                    <Form.Item label={t("Address")} {...formItemLayout}>
                      {getFieldDecorator("customerAddress", {
                        initialValue: this.state.customer.customerAddress,
                        rules: [
                          {
                            type: "string",
                            message: t("The input is not valid "),
                          },
                          {
                            required: false,
                            message: t("Please enter customer address"),
                          },
                        ],
                      })(<Input />)}
                    </Form.Item>
                    <Form.Item label={t("Segment")} {...formItemLayout}>
                      {getFieldDecorator("customerSegment", {
                        initialValue: this.state.customer.customerSegment
                          ? this.state.customer.customerSegment
                          : defaultSegment,

                        rules: [
                          {
                            required: false,
                            message: t("Please select customer segment"),
                          },
                        ],
                      })(
                        <Select placeholder={t("Select ")}>
                          {customerSegmentsOptions}
                        </Select>
                      )}
                    </Form.Item>
                    <Form.Item
                      wrapperCol={{
                        xs: { span: 24, offset: 0 },
                        sm: { span: 16, offset: 8 },
                      }}
                    >
                      <Button
                        className="button-submit"
                        type="primary"
                        onClick={this.handleConfirm}
                        size={"small"}
                        loading={this.state.loading}
                        style={{ marginBottom: "20px" }}
                      >
                        {t("Submit")}
                      </Button>
                    </Form.Item>
                  </Form>
                ) : (
                  <Card
                    style={{
                      marginTop: "10px",
                      boxShadow: "0 2px 8px rgba(0, 0, 0, 0.15)",
                    }}
                    bordered={false}
                  >
                    <Form className="form-style" {...formItemLayout}>
                      <Form.Item label={t("Full Name")} {...formItemLayout}>
                        {getFieldDecorator("customerFullname", {
                          initialValue: this.state.customer.customerFullname,
                          rules: [
                            {
                              type: "string",
                              message: t("The input is not valid "),
                            },
                            {
                              required: true,
                              message: t("Please enter customer full name"),
                            },
                          ],
                        })(<Input />)}
                      </Form.Item>

                      <Form.Item label={t("Number")} {...formItemLayout}>
                        {getFieldDecorator("customerNumber", {
                          initialValue: this.state.customer.customerNumber,
                          rules: [
                            {
                              type: "string",
                              message: t("The number is not valid"),
                              max: 12,
                              min: 12,
                              pattern: "^([2][0][1])(?:[0]|[1]|[2]|[5])[0-9]*$",
                            },
                            {
                              required: true,
                              message: t("Please enter customer number"),
                            },
                          ],
                        })(<Input maxLength={12} placeholder="201XXXXXXXXX" />)}
                      </Form.Item>

                      <Form.Item label={t("Email")} {...formItemLayout}>
                        {getFieldDecorator("customerEmail", {
                          initialValue: this.state.customer.customerEmail,

                          rules: [
                            {
                              type: "email",
                              message: t("The input is not valid E-mail!"),
                            },
                            {
                              type: "string",
                              message: t("The input is not valid "),
                            },
                            {
                              required: false,
                              message: t("Please enter customer email"),
                            },
                          ],
                        })(<Input />)}
                      </Form.Item>

                      <Form.Item label={t("Address")} {...formItemLayout}>
                        {getFieldDecorator("customerAddress", {
                          initialValue: this.state.customer.customerAddress,
                          rules: [
                            {
                              type: "string",
                              message: t("The input is not valid "),
                            },
                            {
                              required: false,
                              message: t("Please enter customer address"),
                            },
                          ],
                        })(<Input />)}
                      </Form.Item>
                      <Form.Item label={t("Segment")} {...formItemLayout}>
                        {getFieldDecorator("customerSegment", {
                          initialValue: this.state.customer.customerSegment
                            ? this.state.customer.customerSegment
                            : defaultSegment,

                          rules: [
                            {
                              required: false,
                              message: t("Please select customer segment"),
                            },
                          ],
                        })(
                          <Select placeholder={t("Select ")}>
                            {customerSegmentsOptions}
                          </Select>
                        )}
                      </Form.Item>
                      <Form.Item
                        wrapperCol={{
                          xs: { span: 24, offset: 0 },
                          sm: { span: 16, offset: 8 },
                        }}
                      >
                        <Button
                          className="button-submit"
                          type="primary"
                          onClick={this.handleConfirm}
                          size={"small"}
                          loading={this.state.loading}
                        >
                          {t("Submit")}
                        </Button>
                      </Form.Item>
                    </Form>
                  </Card>
                )}

                {/* <div>
                <Customer></Customer>
              </div> */}
              </div>
            )}
          </Page>
        )}
      </Translation>
    );
  }
}
export default Form.create()(
  withSharedStateConsumer(withRouter(CreateCustomerForm))
);
